<div>{{ value }}</div>